import useEmotionStyles from "@styles/shared/useEmotionStyles";
import { StudentResultStyle } from "@styles/student-portal/StudentResultStyle";
import { RubricTable as CommonRubricTable } from "@components/common/RubricTable";
import { IRubricInfo } from "@repositories/model/transfer/IRubricInfo";

type Props = {
	rubrics: IRubricInfo[];
}

export const RubricTable = (props: Props) => {
	const classes = useEmotionStyles(StudentResultStyle);
	const { rubrics } = props;

	return (
		<CommonRubricTable
			rubrics={rubrics}
			variant="export"
			classes={classes}
		/>
	);
};
